import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'
import { useWorkorderBaseRoute } from 'utils/Subscription/pathAndRouteSelector'
import { useWorkorderContext } from 'contexts/WorkorderContext/use-workorder-context'
import { useHistory } from 'react-router-dom'

export const useOpenOrderForPart = () => {
  const orderAccountUUID = useSelector((state: IRootReducerState) => state.settings.defaultOrderAccount.defaultOrderAccountUUID)
  const { getWorkorderUUID } = useWorkorderContext()
  const baseURL = useWorkorderBaseRoute()
  const navigation = useHistory()

  const openOrder = async (searchString: string) => {
    const orderUUID = await getWorkorderUUID({})
    navigation.push(`${baseURL}${orderUUID}/search-products/${orderAccountUUID}/${encodeURIComponent(searchString)}`)
  }

  return openOrder
}
